import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import classNames from 'classnames';

import CREDIT_MANAGEMENT_SIDEBAR_DATA from 'data/creditManagementSidebarData';
import ElementSpacePlaceholder from 'components/ElementSpacePlaceholder';
import NavBar from 'components/NavBar';
import styles from './CreditManagementSidebar.module.scss';
import WithPermissions from 'components/WithPermissions';

export default function CreditManagementSidebar() {
  return (
    <>
      <NavBar
        title="CREDIT MANAGEMENT TOOL"
        className="p-xs"
        id="credit-management-sidebar"
      />
      <ElementSpacePlaceholder elementId="credit-management-sidebar" />
      <div className={styles.root}>
        {CREDIT_MANAGEMENT_SIDEBAR_DATA.map((data, sectionIndex) => (
          <div
            className={styles.section}
            key={`creit-manage-sidebar-${sectionIndex}`}
          >
            <div
              className={classNames('bold', 'dark', styles.header)}
              key={sectionIndex}
            >
              {data.header}
            </div>
            <div className={styles.tabs}>
              {data.tabs.map((tab, tabIndex) => (
                <WithPermissions
                  key={`credit-management-tabs-${tabIndex}`}
                  subject={tab.subject}
                  permissions={tab.permissions}
                >
                  <NavLink
                    to={tab.to}
                    tabIndex={tabIndex}
                    className={({ isActive }) =>
                      classNames(styles.tab, { [styles.tabActive]: isActive })
                    }
                  >
                    {tab.tabName}
                  </NavLink>
                </WithPermissions>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className={styles.page}>
        <Outlet />
      </div>
    </>
  );
}
